import PublicSheetWidget from "QuorumGrassroots/widgets/PublicSheet/components/index"

export default PublicSheetWidget
